<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-watermark">
            <template #title v-if="id">
                <Банер>: <b>{{ banner.name }} #{{ id }}</b> <br>
            </template>
            <template #title v-else>
                Новий банер
            </template>

            <ButtonComeBack class="ml-3 mb-3" />
            <!-- {{ banner }} -->
            <v-row>
                <v-col cols="12" lg="6">
                    <v-form class="form-banner-edit" lazy-validation v-model="isValidForm" ref="formBanner">
                        <!-- ID -->
                        <v-col cols="12" v-if="banner.id">
                            <v-text-field label="ID" v-model="banner.id" readonly />
                        </v-col>
                        <!-- Проєкт -->
                        <!-- {{ projectId }} -->
                        <v-col cols="12">
                            <v-select v-model="banner.project_id" label="Проекти" cache-items item-text="name"
                                item-value="id" :items="projectList" required :rules="[v => !!v > 0 || errorRequired]"
                                prepend-icon="mdi-format-list-bulleted-type">
                            </v-select>
                        </v-col>
                        <!-- Назва -->
                        <v-col cols="12">
                            <v-text-field label="Назва" v-model="banner.name" :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- URL -->
                        <v-col cols="12">
                            <v-text-field label="URL" v-model="banner.url" />
                        </v-col>
                        <!-- Термін дії -->
                        <v-col cols="12">
                            <v-switch v-model="banner.all_time" label="Завжди включено"></v-switch>
                        </v-col>
                        <v-col md="3" v-if="!banner.all_time">
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="banner.from_date" label="Термін дії з"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="banner.from_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(banner.from_date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col md="3" v-if="!banner.all_time">
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="banner.to_date" label="Термін дії по"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="banner.to_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu2.save(banner.to_date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>


                        <!-- ------------------------------ Позиція ------------------------------ -->
                        <v-col cols="12">
                            <div class="text-h3">Місце виводу банеру:</div>
                            <v-checkbox v-model="positions.main" label="Стартова сторінка" hide-details></v-checkbox>
                            <v-checkbox v-model="positions.popup" label="Попап на стартовій сторінці"
                                hide-details></v-checkbox>
                            <v-treeview :open.sync="opened" @input="saveCat()" v-model="selection" class="ml-n3 pt-4"
                                :items="firstLevelCatalog" selectable dense return-object
                                selected-color="primary"></v-treeview>
                            <v-treeview :open.sync="openedG" @input="saveCatG()" v-model="selectionG" class="ml-n3"
                                :items="goodsCatalog" selectable dense return-object
                                selected-color="primary"></v-treeview>

                        </v-col>


                        <!-- ----------------------------- ТАБИ ----------------------------- -->
                        <v-col cols="12">
                            <v-tabs v-model="tab">
                                <v-tab v-for="local in localization" :key="local.lang_key">
                                    {{ local.name }}
                                </v-tab>
                            </v-tabs>
                        </v-col>

                        <!--Содержымое табов-->
                        <v-col cols="12">
                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="(item, index) in banner.langs" :key="item.lang_key" :eager="true">
                                    <template>
                                        <!--Текст-->
                                        <v-text-field label="Заголовок" v-model="item.title" required
                                            :rules="[v => true]" />
                                        <!--Текст-->
                                        <v-text-field label="Текст" v-model="item.text" required :rules="[v => true]" />
                                        <!--Назва кнопки-->
                                        <v-text-field label="Назва кнопки" v-model="item.button" required
                                            :rules="[v => true]" />
                                        <!--Изображение-->
                                        <ImageUpload v-model="item.image"
                                            @image-upload:change="changeImageList($event, item.lang_key)"
                                            :imageBaseUrl="imageBaseUrl" />
                                    </template>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>

                        <!-- ------------------------------- Кнопки ------------------------------- -->
                        <v-col cols="12" class="text-right">
                            <v-btn color="primary" min-width="150" @click="updateBanner()">
                                Зберегти
                            </v-btn>
                        </v-col>
                        <Preloader v-if="isSending" />
                    </v-form>

                </v-col>
            </v-row>
        </material-card>
    </v-container>
</template>


<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'PageBannerProfile',
    props: {
        id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            enabled: false,
            banner: {
                langs: [],
                all_time: true,
                project_id: null
            },
            opened: [{
                id: 0
            }],
            selection: [],
            selectionG: [],
            items: [],
            // Нужно vuetify для валидации формы
            isValidForm: true,
            // Сообщение об ошибке для обязательных полей
            errorRequired: `Це поле обов'язкове`,
            // Указывает на то что выполняется отправка формы
            isSending: false,
            // Изображения для отправки 
            imagesToSend: {},
            bannerImage: null,//'/assets/img/banners/2v9aj5numrmm1g710skx3wmy0wt3m5sp.png',
            // Базовый url картинки
            imageBaseUrl: `${IMAGE_BASE_URL}banners/`,
            menu: false,
            menu2: false,
            tab: 0,
            positions: {
                main: false,
                popup: false,
                catalog: [],
                menu: []
            },
            projectList: [],
            catalog: [],
            openedG: [],
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization', 'isManager', 'isAdmin']),
        firstLevelCatalog() {
            const cat = this.catalog.filter(item => item.level == 1).map(item => ({ ...item, children: [] }));
            // додати корінь з id 0
            return [{ id: 0, name: 'Меню сайту', level: 0, children: cat }];
        },
        goodsCatalog() {
            return [{ id: 0, name: 'Каталог товарів', level: 0, children: this.catalog }];
        },
        positionChecked() {
            return this.positions.main || this.positions.popup || this.positions.catalog.length || this.positions.menu.length;
        },
        someImageChecked() {
            return this.banner.langs.some(item => item.image) || this.imagesToSend && Object.keys(this.imagesToSend).length;
        },
        projectId() {
            return this.banner.project_id;
        },

    },
    async mounted() {
        await this.init();
    },
    watch: {
        projectId: {
            handler(newVal, oldVal) {
                this.getCatalog();
                // Очистить выбранные категории
                // this.selection = [];
                // this.selectionG = [];
                // this.positions.menu = [];
                // this.positions.catalog = [];
            },
            immediate: false
        }
    },
    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        async init() {

            await this.getLocalization();
            await this.getProjectList();

            if (this.id) {
                const data = await this.getBanner();
                // Встановити позиції
                this.setPositions();
            } else {
                this.banner.langs = this.localization.map((el) => {
                    return {
                        lang_key: el.lang_key,
                        lang_name: el.name,
                        name: '',
                        preview: '',
                        text: '',
                    };
                });
            }

        },
        collectByIds(tree, ids) {
            const result = []
            const idsSet = new Set(ids) // O(1) доступ

            function traverse(nodes) {
                for (const node of nodes) {
                    // якщо це лист і його id є в positions
                    if (idsSet.has(node.id) && !node.children) {
                        result.push(node)
                    }

                    if (node.children?.length) {
                        traverse(node.children)
                    }
                }
            }

            traverse(tree)
            return result
        },
        setPositions() {
            this.positions = { ...this.banner.positions };
            // Встановити вибрані елементи в дереві
            setTimeout(() => {
                this.selection = this.catalog.filter(item => {
                    return this.positions.menu.includes(Number(item.id))
                });
                this.selectionG = this.collectByIds(this.goodsCatalog, this.positions.catalog);
            }, 100);
        },
        changeImageList(data, langKey) {
            if (data.action) {
                this.$set(this.imagesToSend, langKey, { 'sendImage': data.sendImage });
            } else {
                delete this.imagesToSend[langKey];
            }
        },
        async runProcessImagesSend(id) {
            let errors = '';
            for (let key in this.imagesToSend) {
                let item = this.imagesToSend[key];
                let queryParams = {
                    lang_key: key,
                    object_image_id: id,
                    image_type: 'banner_image',
                };
                let result = await item.sendImage(queryParams);
                // Если при загрузке изображений были - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                }
            }
            this.isSending = false;
        },

        // Зберегти вибрані категорії
        saveCat() {
            this.positions.menu = this.selection.map(item => item.id);
        },
        saveCatG() {
            this.positions.catalog = this.selectionG.map(item => item.id);
        },
        // Получить каталог
        async getCatalog() {
            try {
                const {
                    data
                } = await HTTP.post('/get-catalog', {
                    project: this.projectId
                });
                this.catalog = data?.content?.catalog || [];
            } catch (error) {
                console.warn(error);
            }
        },


        async getBanner() {
            let { data } = await HTTP.post('/get-banner', { 'id': this.$route.params.id });
            this.banner = data.content;
            this.banner.langs.map(item => {
                item.image = item.image ? `${this.imageBaseUrl}${item.image}` : '';
                return item;
            });
            return data.content;
        },

        // Изменить список картинок 
        changeImage(data, langKey) {
            if (data.action) {
                this.imagesToSend[langKey] = {
                    sendImage: data.sendImage
                };
            } else {
                delete this.imagesToSend[langKey];
            }
        },



        async updateBanner() {
            let queryParams = { ...this.banner, positions: this.positions };

            if (this.isSending) return;
            if (!this.$refs.formBanner.validate()) {
                this.setSnackbar({ type: 'error', text: 'Форма заповнена не вірно' });
                return;
            }

            if (!this.someImageChecked) {
                this.setSnackbar({ type: 'error', text: 'Потрібно завантажити хоча б одне зображення' });
                return;
            }

            // if (!this.positionChecked) {
            //     this.setSnackbar({ type: 'error', text: 'Потрібно вибрати місце виводу банера' });
            //     return;
            // }

            this.isSending = true;

            try {
                const { data } = await HTTP.post(this.banner.id ? '/update-banner' : '/create-banner', queryParams);

                let isImages = Object.keys(this.imagesToSend)?.length;

                this.setSnackbar({
                    type: 'success',
                    text: `Данні оновлено. ${isImages ? 'Виконується завантаження зображень.' : ''}`
                });

                if (!isImages) {
                    this.isSending = false;
                }
                // сделал через $watch потомучто setSnackbar сделан через "mutation" (не может вернуть промис)
                const unwatch = this.$watch('snackbar.model', function (newVal, oldVal) {
                    unwatch();
                    // Запускаем загрузку изображений
                    if (isImages) {
                        this.runProcessImagesSend(this.banner.id || data.content.insertId);
                    }
                });
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },

        // Запускает процесс отравки изображений, отправкой занимается "ImageUpload"
        async runProcessImagesSend(id) {
            let errors = '';
            for (let key in this.imagesToSend) {
                let item = this.imagesToSend[key];
                let queryParams = {
                    lang_key: key,
                    object_image_id: id,
                    image_type: 'banner_image',
                };

                let result = await item.sendImage(queryParams);
                // Если при загрузке изображений были - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                }
            }
            this.isSending = false;
        },
        // Получить список проектов
        async getProjectList() {
            try {
                let { data } = await HTTP.post('/get-projects');
                this.projectList = data.content;
            } catch (error) {
                console.warn(error);
            }
        },

    },
}
</script>

<style scoped lang="sass">
  .form-banner-edit
    position: relative
  </style>
